import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=3ae789b7&scoped=true&"
import script from "./ModalBase.vue?vue&type=script&lang=ts&"
export * from "./ModalBase.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=3ae789b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae789b7",
  null
  
)

export default component.exports